const logger = require('debug')('careship:store/auth')

export default {
  authRequest(state) {
    state.status = 'loading'
  },

  setUserToken(state, value) {
    localStorage.setItem('userToken', value.access_token)
    state.userToken = value.access_token

    localStorage.setItem('userRefreshToken', value.refresh_token)
    state.userRefreshToken = value.refresh_token

    state.status = 'success'
  },

  authError(state) {
    localStorage.removeItem('token')
    state.status = 'error'
  },

  deleteUserToken(state) {
    localStorage.removeItem('userToken')
    state.userToken = undefined
  },

  setConfigToken(state, value) {
    localStorage.setItem('configToken', value)
    state.configToken = value
  },

  deleteAuth(state) {
    logger(
      'deleteAuth -> will delete all authentication bits from the store and localStorage',
    )
    ;['userToken', 'userRefreshToken'].forEach(key => {
      logger('store.mutation -> auth/deleteAuth -> deleting key %s...', key)
      state[key] = undefined
      localStorage.removeItem(key)
    })
  },

  deleteConfigToken(state) {
    localStorage.removeItem('configToken')
    state.configToken = undefined
  },
}
